import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { theme } from '../../services/theme';
import { BoxRow } from '../BoxRow';
import { Dialog } from '../Dialog';
import { Spacer } from '../Spacer';

interface Props {
  isOpen: boolean;
  message?: string;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  closeTitle?: string;
  submitTitle?: string;
}

export const Confirm: FC<Props> = ({
  closeTitle = 'Cancel',
  isOpen,
  message,
  onClose,
  onSubmit,
  submitTitle = 'Submit',
  title,
}) => (
  <Dialog
    isOpen={isOpen}
    onClose={onClose}
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      padding: '30px 100px',
      [theme.breakpoints.down('sm')]: {
        padding: '20px 30px',
      },
      [theme.breakpoints.down('mobile')]: {
        padding: '20px 10px',
      },
    }}
    withCloseIcon={false}
  >
    <Typography
      fontWeight="regular"
      sx={{
        color: '#356482',
        fontSize: '24px',
        lineHeight: '34px',
        marginBottom: '20px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
          fontSize: '18px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down('mobile')]: {
          fontSize: '16px',
          lineHeight: '18px',
        },
      }}
    >
      {title}
    </Typography>
    {message && (
      <Typography
        fontWeight="regular"
        sx={{
          color: 'rgba(53, 100, 130, 0.7)',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '22px',
          marginBottom: '12px',
          textAlign: 'center',
          [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            lineHeight: '16px',
          },
          [theme.breakpoints.down('mobile')]: {
            fontSize: '12px',
            lineHeight: '14px',
          },
        }}
      >
        {message}
      </Typography>
    )}
    <BoxRow sx={{ marginTop: '20px' }}>
      <Button
        onClick={onClose}
        sx={{
          flex: 1,
          height: '40px',
        }}
        variant="outlined"
      >
        {closeTitle}
      </Button>
      <Spacer width="20px" />
      <Button
        onClick={onSubmit}
        sx={{
          flex: 1,
          height: '40px',
        }}
        variant="contained"
      >
        {submitTitle}
      </Button>
    </BoxRow>
  </Dialog>
);
